var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lds-container"},[(!_vm.loading)?[(_vm.info)?_c('CentrmamaReport',{attrs:{"info":_vm.info}}):_c('NotFound')]:_c('Loader')],2)}
var staticRenderFns = []

export { render, staticRenderFns }